import React, { useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useCartContext } from '../../../Contexts/CartContext';
import CardProductCartConference from './CardProductCartConference';
import { TbShoppingBagPlus, TbTrash } from 'react-icons/tb';
import Modal from '../Modal';
import EditObservationConference from '../Product/EditObservationConference';
import { useStoreHook } from '../../../Hooks/StoreHook';
import Confirm from '../Confirm';
import { useCartHook } from '../../../Hooks/CartHook';
import BoxContentConfirmTable from './BoxContentConfirmTable';

interface CartConferenceProps {
    cart: any;
    onCloseCart: CallableFunction;
}

const CartConference = ({cart, onCloseCart}: CartConferenceProps) => {

    const { cartDisplay, deleteProductFromConference, updateProductInConference, updateObservationProductInConference, setCartConference, setShowCartConference, setShowConfirmTable, setShowTablesToChoice } = useCartContext();
    const [showEditProduct, setShowEditProduct] = useState(false);
    const [showConfirmResetCartConference, setShowConfirmResetCartConference] = useState(false);
    const [currentProductToEdit, setCurrentProductToEdit] = useState<any>(null);
    const { storeIsOpen } = useStoreHook();
    const { handleSend } = useCartHook();

    const handSendCheckTable = () => {
        if (cartDisplay.table.id) {
            handleSend();
        } else {
            handleChoiceTable()
        }
    }
    const handleChoiceTable = () => {
        //* Verificando horários de funcionamento
        if (storeIsOpen()) {
            setShowConfirmTable(true);

            //* timeout utilizado para abrir a lista de mesas independente da regra do <TableChoice />
            setTimeout(() => {
                setShowTablesToChoice(true);
            }, 50);
        }
    }
    const handleUpdate = (itemConferenceId: number, quantity: number) => {
        updateProductInConference(itemConferenceId, quantity);
    }

    const handleDelete = (itemConferenceId: number) => {
        deleteProductFromConference(itemConferenceId);
    }

    const handleCardClick = (product: any) => {
        setShowEditProduct(true);
        setCurrentProductToEdit(product);
    }

    const handleCancelEditProduct = () => {
        setShowEditProduct(false);
        setCurrentProductToEdit(null);
    }

    const handleConfirChangeEdit = (observation: string) => {
        updateObservationProductInConference(currentProductToEdit.itemConferenceId, observation);
        handleCancelEditProduct();
    }

    const handleResetCartConference = () => {
        setShowConfirmResetCartConference(false);
        setCartConference([]);
        setShowCartConference(false);
    }

    return (
        <section className='p-4 pt-0 h-full'>

            <section className="flex flex-col justify-between h-full gap-4">
                <div className='flex flex-col gap-3 w-full h-full md:overflow-y-auto'>

                    <div className='h-full min-h-32 gap-10'>
                        <Scrollbars autoHide={true}>
                            <div className='flex flex-col divide-y divide-gray-100'>
                                {cart.map((product: any, index: number) =>
                                    <CardProductCartConference
                                        product={product}
                                        onDec={(quantity: number) => handleUpdate(product.itemConferenceId, quantity)}
                                        onInc={(quantity: number) => handleUpdate(product.itemConferenceId, quantity)}
                                        onDelete={() => handleDelete(product.itemConferenceId)}
                                        key={product.itemConferenceId}
                                        onCardClick={() => handleCardClick(product)}
                                    />
                                )}
                                {cart.length > 1 &&
                                    <div className='py-4 pr-2 text-right'>
                                        <button onClick={() => setShowConfirmResetCartConference(true)}
                                            className='inline-flex items-center justify-end gap-0.5 text-xs text-gray-400 hover:text-shopfood-danger font-medium transition-all'
                                            >
                                            <TbTrash /> Remover tudo
                                        </button>
                                    </div>
                                }
                            </div>
                        </Scrollbars>
                    </div>
                </div>

                <BoxContentConfirmTable show={cartDisplay?.table.id} tableName={cartDisplay?.table.name} onClickConfirm={handleChoiceTable} />

                <div className="flex gap-2 w-full">
                    <ButtonPrimary outline onClick={() => onCloseCart(false)} className='w-full text-sm gap-0.5'>
                        <div><TbShoppingBagPlus size={20} className='-mt-0.5' /></div>
                        <span>Produtos</span>
                    </ButtonPrimary>
                    <ButtonPrimary onClick={handSendCheckTable} className='w-full text-sm gap-0.5'>
                        Enviar pedido
                    </ButtonPrimary>
                </div>
            </section>

            {/* MODAL OBSERVACAO DO PRODUTO */}
            {currentProductToEdit &&
                <Modal open={showEditProduct} className="max-w-sm m-4" onClose={() => handleCancelEditProduct()}>
                    <EditObservationConference
                        product={currentProductToEdit}
                        onConfirm={(observation: string) => handleConfirChangeEdit(observation)}
                        onCancel={() => handleCancelEditProduct()}
                    />
                </Modal>
            }

            {/* MODAL CONFIRM RESET CONFERENCE CART */}
            <Modal open={showConfirmResetCartConference} className="max-w-md m-4" onClose={() => setShowConfirmResetCartConference(false)}>
                <Confirm
                    onConfirm={handleResetCartConference}
                    onCancel={() => setShowConfirmResetCartConference(false)}
                    title="Tem certeza?"
                    message='Deseja realmente remover todos os itens do seu pedido?'
                    labelConfirm="Sim, quero remover"
                />
            </Modal>

        </section>
    );
};

export default CartConference;
